import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@americanexpress/dls-react';
import cardStyle from './view-all-tile/view-all-tile.css';

import { renderHtml } from './utils/render-html';

const BodySansCatalog = ({ title, shortDescription, children }) => (
  <div className="position-relative">
    <Heading level={3} variant="sans-small-regular color-text-subtle" className="margin-1-b">
      {renderHtml(title)}
    </Heading>
    {children}
    <div className={`body-small ${cardStyle.card} color-text-subtle`}>
      {renderHtml(shortDescription)}
    </div>
  </div>
);

BodySansCatalog.propTypes = {
  title: PropTypes.string.isRequired,
  shortDescription: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.bool,
  ]),
};

export default BodySansCatalog;
